import styled from 'styled-components';
import classNames from 'classnames';

type HeadlineBannerProps = {
  title: string;
  subtitle: string;
  wide?: boolean;
  className?: string;
};

export const HeadlineBanner: React.FC<HeadlineBannerProps> = ({ title, subtitle, wide = false, className = '' }) => {
  return (
    <StyledHeadlineBanner>
      <div className={classNames(className, `inner ${wide ? '' : 'small-'}outer-padding`)}>
        <div className="headline">
          {title && <h1>{title}</h1>}
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
    </StyledHeadlineBanner>
  );
};

const StyledHeadlineBanner = styled.div`
  background: var(--primary-base);
  color: var(--text-invert);
  margin-bottom: 3rem;

  .headline {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
`;

export default HeadlineBanner;
